module.exports = __webpack_public_path__ + "src/assets/img/customer-logos/asana.9b149363bad9a7bf7df49ec14e7fdff9.png";